import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

export type NotificationKey = `id:${string}-updatedAt:${string}`;

type NotificationsState = {
  notificationsDismissed: { [key: NotificationKey]: boolean };
};

type NotificationsActions = {
  resetNotifications: () => void;
  dismissNotification: (key: NotificationKey) => void;
  getNotificationsDismissed: (key: NotificationKey) => boolean | undefined;
  getAllNotificationsDismissed: () => { [key: NotificationKey]: boolean };
};

const initialState: NotificationsState = {
  notificationsDismissed: {},
};

// used for keeping track of dismissed notifications, if true, the notification is dismissed
// if it is false or undefined, the notification is not dismissed
export const createNotificationsSlice: WaterlyAppStateCreator<NotificationsActions, NotificationsState> = (
  set,
  get,
) => ({
  ...initialState,
  getNotificationsDismissed: (key: NotificationKey) => {
    const { notificationsDismissed } = get();
    return notificationsDismissed[key];
  },
  getAllNotificationsDismissed: () => {
    const { notificationsDismissed } = get();
    return notificationsDismissed;
  },
  dismissNotification(key: NotificationKey) {
    set(
      (state) => {
        state.notificationsDismissed[key] = true;
      },
      false,
      "notifications:dismissNotification",
    );
  },
  resetNotifications: () => {
    set(initialState);
  },
});
